<div>
  <section  class="mt-section">
    <v-grid in="10">
      <v-row class="mt-group">
        <v-col has="10">
          <div class="mt-serif mt-serif--bold mt-serif--size6" :class="$style.label">
            {{$t('pages.promotions.new_promotion.form_details.promo_image.label')}}
          </div>
        </v-col>
      </v-row>
    </v-grid>
    <div class="mt-5">
      <p class="mt-serif mt-serif--size6" :class="$style.mB20">
        {{$t('pages.promotions.new_promotion.form_details.promo_image.description')}}
      </p>
      <p class="mt-serif mt-serif--size6">
        {{$t('pages.promotions.new_promotion.form_details.promo_image.upload_specifications.header')}}
      </p>
      <ul class="mt-serif mt-serif--size6 mt-list mt-list--padded mt-list--disc">
        <li class="mt-list-item">
          <span v-html="$sanitize($t('pages.promotions.new_promotion.form_details.promo_image.upload_specifications.items.prices'))"></span>
        </li>
        <li class="mt-list-item">
          <span v-html="$sanitize($t('pages.promotions.new_promotion.form_details.promo_image.upload_specifications.items.size', {
            minWidth: minImageWidth,
            minHeight: minImageHeight,
        }))"></span>
        </li>
        <li class="mt-list-item">
          <span v-html="$sanitize($t('pages.promotions.new_promotion.form_details.promo_image.upload_specifications.items.types'))"></span>
        </li>
        <li class="mt-list-item">
          <span v-html="$sanitize($t('pages.promotions.new_promotion.form_details.promo_image.upload_specifications.items.quantity'))"></span>
        </li>
      </ul>
    </div>
    <fou-group>
      <graphic-uploader :imageURL="hasImageURL()" :id="$vId(this, 'graphic-uploader')" />
      <promo-image-viewer :imageURL="hasImageURL()" :id="$vId(this, 'image-viewer')" />
    </fou-group>
  </section>
</div>
